import 'css-chunksrc/client/scenes/resourcesListingConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_151qu_1",
  "listRoot": "_listRoot_151qu_14",
  "list": "_list_151qu_14",
  "item": "_item_151qu_30",
  "icon": "_icon_151qu_43",
  "timeSheetIcon": "_timeSheetIcon_151qu_51",
  "name": "_name_151qu_56"
};